"use client"

import { useState } from "react"
import Link from "next/link"
import { Menu } from "lucide-react"
import Image from "next/image"

import { siteConfig } from "@/config/site"
import { Button } from "@/components/ui/button"
import {
  NavigationMenu,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet"

const navigation = [
  { href: "/#about", text: "Бидний тухай" },
  // { href: "/#features", text: "Онцлог" },
  { href: "/courses", text: "Сургалт" },
  { href: "/scholarships", text: "Тэтгэлэг" },
  // { href: "https://apply.mbg.mn", text: "Тэтгэлэг" },

  { href: "/news", text: "Мэдээ, мэдээлэл" },
]

export function Header() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header className="sticky top-0 w-full bg-primary text-primary-foreground border-b border-primary-foreground/10 z-50 shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link
            href="/"
            className="flex items-center space-x-2"
            onClick={() => setIsOpen(false)}
          >
            <div className="flex w-10 h-10 justify-center items-center bg-white/10 rounded-full">
              <Image src="/logo.png" alt="logo" width={40} height={40} className="object-contain p-1" />
            </div>
            <span className="text-xl font-bold">{siteConfig.name}</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <NavigationMenu>
              <NavigationMenuList className="flex space-x-8">
                {navigation.map((link, index) => (
                  <NavigationMenuLink key={index} asChild>
                    <Link
                      href={link.href}
                      className="hover:text-accent transition-colors px-3 py-2 rounded-lg font-medium"
                    >
                      {link.text}
                    </Link>
                  </NavigationMenuLink>
                ))}
              </NavigationMenuList>
            </NavigationMenu>

            <Button variant="secondary" className="bg-white text-primary hover:bg-white/90 font-semibold shadow-sm">
              <Link href="/#contact">Холбоо барих</Link>
            </Button>
          </div>

          {/* Mobile Menu */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                className="md:hidden text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
                aria-label={isOpen ? "Close menu" : "Open menu"}
              >
                <Menu className="w-6 h-6" />
              </Button>
            </SheetTrigger>
      
            <SheetContent side="right" className="w-[300px] sm:w-[400px]">
              <SheetHeader>
                <SheetTitle>
                  <Link
                    href="/"
                    className="flex items-center space-x-2"
                    onClick={() => setIsOpen(false)}
                  >
                    <div className="flex shadow-xl rounded-full  w-10 h-10 justify-center items-center">
                      <Image src="/logo.png" alt="logo" width={40} height={40} />
                    </div>
                    <span className="text-xl">{siteConfig.name}</span>
                  </Link>
                </SheetTitle>
              </SheetHeader>

              <div className="flex flex-col space-y-4 mt-8">
                {navigation.map((link, index) => (
                  <Link
                    key={index}
                    href={link.href}
                    className=" transition-colors py-2 text-lg   border-b border-border last:border-b-0"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.text}
                  </Link>
                ))}

                <div className="pt-4">
                  <Button >
                    <Link href="/#contact" onClick={() => setIsOpen(false)}>
                      Холбоо барих
                    </Link>
                  </Button>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  )
}
